import {Component, OnInit} from '@angular/core';
import {MdAvailabilityService} from '../../../services/mdAvailability.service';
import {UtilsService} from '../../../appSharedModule/services/utils.service';
import {MdAvailability} from '../../../models/mdAvailability';
import {formatDate} from '@angular/common';
import {AuthenticationService} from '../../../authenticationModule/services/authentication.service';
import {SelectItem} from 'primeng/api';
import {TechnicalPopService} from '../../../services/technical-pop.service';

@Component({
  selector: 'apcol-md-availability',
  templateUrl: './md-availability.component.html',
  styleUrls: ['./md-availability.component.scss']
})
export class MdAvailabilityComponent implements OnInit {

  mdAvailabilities: MdAvailability[] = [];
  mdAvailabilitiesIncludingUat: MdAvailability[] = [];
  filteredMdAvailabilities: MdAvailability[] = [];
  cols = [
    {field: 'technicalPop', header: 'Technical Pop', sortDisabled: false},
    {field: 'service', header: 'Service', sortDisabled: true},
    {field: 'market', header: 'Market', sortDisabled: true},
    {field: 'platform', header: 'Platform', sortDisabled: true},
    {field: 'options', header: 'Options', sortDisabled: true},
    {field: 'publicDescription', header: 'Public description', sortDisabled: true}
  ];
  filterParams = {
    destinationCPop: null,
    sourceCPop: null,
    market: null,
    service: null,
    arbitrated: true,
    non_arbitrated: true,
    encrypted: true,
    non_encrypted: true,
    protected: true,
    non_protected: true,
    showUAT: false
  };
  success = false;
  successMessage = '';
  possibleMarkets = [];
  possibleMarketsOptions: SelectItem[] = [{label: 'All', value: null}];
  possibleDestinationCPops = [];
  possibleDestinationCPopsOptions: SelectItem[] = [{label: 'All', value: null}];
  possibleSourcePops = [];
  possibleSourcePopsOptions: SelectItem[] = [{label: 'All', value: null}];
  possibleServices = [];
  possibleServicesOptions: SelectItem[] = [{label: 'All', value: null}];

  constructor(
    private mdAvailabilityService: MdAvailabilityService,
    private authService: AuthenticationService,
    protected technicalPopService: TechnicalPopService,
    private utilsService: UtilsService) {
  }

  ngOnInit() {
    this.utilsService.lockUi();
    if (this.authService.userCurrent.roles.includes('ROLE_MCKAY')) {
      this.cols.push(
        {field: 'updatedBy', header: 'Updated by', sortDisabled: true},
        {field: 'updatedAt', header: 'Updated at', sortDisabled: true},
      );
    }
    this.getMdAvailabilities();
  }

  private getMdAvailabilities() {
    this.mdAvailabilityService.getMdAvailabilities().subscribe(res => {
      this.mdAvailabilities = this.initMdAvailabilities(res);
      this.filteredMdAvailabilities = this.mdAvailabilities;
      this.utilsService.unlockUi();
    });
  }

  private initMdAvailabilities(res: MdAvailability[]) {
    res.forEach(mdAvailability => {
      this.initDestinationPopFilter(mdAvailability);
      mdAvailability.markets.forEach(market => {
        this.initMarketFilters(market);
        market.newPublicDescription = market.publicDescription;
        if (market.updatedAt) {
          market.updatedAt = formatDate(market.updatedAt, 'yyyy-MM-dd HH:mm:ss', 'en-US', 'UTC') + ' (UTC)';
        }
        market.textAriaRows = 1;
      });
    });
    this.possibleSourcePopsOptions.sort((a, b) => a.label && a.label.localeCompare(b.label));
    this.possibleMarketsOptions.sort((a, b) => a.label && a.label.localeCompare(b.label));
    this.possibleServicesOptions.sort((a, b) => a.label && a.label.localeCompare(b.label));
    return res;
  }

  private initMarketFilters(market) {
    if (!this.possibleSourcePops.includes(market.cPopDisplayId)) {
      this.possibleSourcePops.push(market.cPopDisplayId);
      this.possibleSourcePopsOptions.push({label: market.cPopDisplayId, value: market.cPopDisplayId});
    }
    if (!this.possibleMarkets.includes(market.name)) {
      this.possibleMarkets.push(market.name);
      this.possibleMarketsOptions.push({label: market.name, value: market.name});
    }
    if (!this.possibleServices.includes(market.service)) {
      this.possibleServices.push(market.service);
      this.possibleServicesOptions.push({label: market.service.toUpperCase(), value: market.service});
    }
  }

  private initDestinationPopFilter(mdAvailability: MdAvailability) {
    if (!this.possibleDestinationCPops.includes(mdAvailability.cPop)) {
      if (mdAvailability.cPop.includes(',')) {
        const cpops = mdAvailability.cPop.split(',');
        cpops.forEach(cpop => {
          this.possibleDestinationCPops.push(cpop);
          this.possibleDestinationCPopsOptions.push({label: cpop, value: cpop});
        });
      } else {
        this.possibleDestinationCPops.push(mdAvailability.cPop);
        this.possibleDestinationCPopsOptions.push({label: mdAvailability.cPop, value: mdAvailability.cPop});
      }
      this.possibleDestinationCPopsOptions.sort((a, b) => a.label.localeCompare(b.label));
    }
  }

  filter() {
    if (this.filterParams.showUAT) {
      this.filteredMdAvailabilities = this.mdAvailabilitiesIncludingUat;
    } else {
      this.filteredMdAvailabilities = this.mdAvailabilities;
    }
    if (this.filterParams.market && this.filterParams.market !== '') {
      this.filterByMarket();
    }
    if (this.filterParams.destinationCPop && this.filterParams.destinationCPop !== '') {
      this.filteredMdAvailabilities = this.filteredMdAvailabilities.filter(mdAvailability => mdAvailability.cPop.toLowerCase().indexOf(this.filterParams.destinationCPop.toLowerCase()) !== -1);
    }
    if (this.filterParams.sourceCPop && this.filterParams.sourceCPop !== '') {
      this.filterBySourceCPop();
    }
    if (this.filterParams.service && this.filterParams.service !== '') {
      this.filterByService();
    }
    if (this.filterParams.arbitrated && !this.filterParams.non_arbitrated || !this.filterParams.arbitrated && this.filterParams.non_arbitrated) {
      this.filterByArbitration();
    }
    if (this.filterParams.encrypted && !this.filterParams.non_encrypted || !this.filterParams.encrypted && this.filterParams.non_encrypted) {
      this.filterByEncryption();
    }
    if (this.filterParams.protected && !this.filterParams.non_protected || !this.filterParams.protected && this.filterParams.non_protected) {
      this.filterByProtection();
    }
  }

  changePublicDescription(market) {
    market.textAriaRows = 1;
    if (market.newPublicDescription === market.publicDescription) {
      return;
    }
    this.mdAvailabilityService.changePublicDescription(market.id, market.newPublicDescription).subscribe(
      () => {
        this.success = true;
        this.successMessage = 'Public description has been updated.';
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
        market.publicDescription = market.newPublicDescription;
        market.updatedBy = this.authService.userAuthenticated.name;
        market.updatedAt = formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss', 'en-US', 'UTC') + ' (UTC)';
      }
    );
  }

  private filterBySourceCPop() {
    const co = [];
    this.filteredMdAvailabilities.forEach(mdAvailability => {
      const mdAvailabilityFiltered = this.initFilterParams(mdAvailability);
      mdAvailabilityFiltered.markets = mdAvailability.markets.filter(market => market.cPopDisplayId && market.cPopDisplayId.toLowerCase().indexOf(this.filterParams.sourceCPop.toLowerCase()) !== -1);
      co.push(mdAvailabilityFiltered);
    });
    this.filteredMdAvailabilities = co;
  }

  private filterByMarket() {
    const co = [];
    this.filteredMdAvailabilities.forEach(mdAvailability => {
      const mdAvailabilityFiltered = this.initFilterParams(mdAvailability);
      mdAvailabilityFiltered.markets = mdAvailability.markets.filter(market => market.name && market.name.toLowerCase().indexOf(this.filterParams.market.toLowerCase()) !== -1);
      co.push(mdAvailabilityFiltered);
    });
    this.filteredMdAvailabilities = co;
  }

  private filterByService() {
    const co = [];
    this.filteredMdAvailabilities.forEach(mdAvailability => {
      const mdAvailabilityFiltered = this.initFilterParams(mdAvailability);
      mdAvailabilityFiltered.markets = mdAvailability.markets.filter(market => market.service && market.service.toLowerCase().indexOf(this.filterParams.service.toLowerCase()) !== -1);
      co.push(mdAvailabilityFiltered);
    });
    this.filteredMdAvailabilities = co;
  }

  private initFilterParams(mdAvailability: MdAvailability) {
    const mdAvailabilityFiltered = {
      technicalPop: '',
      cPop: '',
      markets: [],
    };
    mdAvailabilityFiltered.technicalPop = mdAvailability.technicalPop;
    mdAvailabilityFiltered.cPop = mdAvailability.cPop;
    return mdAvailabilityFiltered;
  }

  private filterByArbitration() {
    const co = [];
    this.filteredMdAvailabilities.forEach(mdAvailability => {
      const mdAvailabilityFiltered = this.initFilterParams(mdAvailability);
      if (this.filterParams.arbitrated) {
        mdAvailabilityFiltered.markets = mdAvailability.markets.filter(market => !!market.options.includes('Arb'));
      } else {
        mdAvailabilityFiltered.markets = mdAvailability.markets.filter(market => !market.options.includes('Arb'));
      }
      co.push(mdAvailabilityFiltered);
    });
    this.filteredMdAvailabilities = co;
  }

  private filterByEncryption() {
    const co = [];
    this.filteredMdAvailabilities.forEach(mdAvailability => {
      const mdAvailabilityFiltered = this.initFilterParams(mdAvailability);
      if (this.filterParams.encrypted) {
        mdAvailabilityFiltered.markets = mdAvailability.markets.filter(market => !!market.platform.includes('crypt'));
      } else {
        mdAvailabilityFiltered.markets = mdAvailability.markets.filter(market => !market.platform.includes('crypt'));
      }
      co.push(mdAvailabilityFiltered);
    });
    this.filteredMdAvailabilities = co;
  }

  private filterByProtection() {
    const co = [];
    this.filteredMdAvailabilities.forEach(mdAvailability => {
      const mdAvailabilityFiltered = this.initFilterParams(mdAvailability);
      if (this.filterParams.protected) {
        mdAvailabilityFiltered.markets = mdAvailability.markets.filter(market => !!market.options.includes('Pro'));
      } else {
        mdAvailabilityFiltered.markets = mdAvailability.markets.filter(market => !market.options.includes('Pro'));
      }
      co.push(mdAvailabilityFiltered);
    });
    this.filteredMdAvailabilities = co;
  }

  isEncrypted(market: any) {
    return market.platform.includes('crypt');
  }

  alterShowUat() {
    if (this.filterParams.showUAT) {
      if (this.mdAvailabilitiesIncludingUat.length > 0) {
        this.filteredMdAvailabilities = this.mdAvailabilitiesIncludingUat;
        this.filter();
        return;
      } else {
        this.mdAvailabilityService.getMdAvailabilityIncludingUat().subscribe(res => {
          this.mdAvailabilitiesIncludingUat = this.initMdAvailabilities(res);
          this.filteredMdAvailabilities = this.mdAvailabilitiesIncludingUat;
          this.filter();
          return;
        });
      }
    }
    this.filteredMdAvailabilities = this.mdAvailabilities;
    this.filter();
  }
}
